export * from './serie.model';
export * from './serie.service';
export * from './serie-form.service';


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/series/shared/index.ts